<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="pa-0 ma-0" cols="12" sm="3">
        <v-text-field
          :autocomplete="autocompleteValueLocal"
          class="mr-3 to-upper"
          :label="$t('vehicles.search')"
          autofocus
          prepend-icon="mdi-magnify"
          v-bind:clearable="true"
          clear-icon="mdi-close"
          v-model="search"
          :outlined="is_boxes"
          :dense="is_boxes"
          @input="debounceInput(); updateLocalStorage();"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-data-table
        :footer-props="{
          'items-per-page-options': dataTableOptions,
        }"
        fixed-header
        :headers="headers"
        :options="options"
        :server-items-length="totalItems"
        :loading-text="this.$t('loading')"
        class="elevation-0"
        :height="'calc(-200px + 100vh)'"
        style="width: 100%"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items-per-page="itemsPerPage"
        item-key="identifier"
        @update:sort-by="updateSort"
        @update:sort-desc="updateSortOrder"
        @update:page="updatePagination"
        @update:items-per-page="updateItemsPerPage"
        :items="properties"
        :key="forceReloadComponentKey"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td @click="editProperty(item)">
              {{ item.id }}
            </td>
            <td @click="editProperty(item)">
              {{ getPropertyName(item) }}
            </td>
            <td @click="editProperty(item)">
              {{ getPropertyIdentifier(item) }}
            </td>
            <!-- <td @click="editProperty(item)">
              {{ getPropertyAddress(item) }}
            </td> -->
            <td @click="editProperty(item)">
              <v-icon color="warning" v-if="item.note" @click.stop="onNoteClick(item)">
                mdi-information
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>
<script>
import axios from "@/plugins/axios";
import _ from "lodash";
import { API_BASE_URL } from "@/config";
import { VIEW_MODE } from "@/config";
import { DEFAULT_ITEMS_PER_PAGE_OPTIONS } from "@/config";

export default {
  name: "PropertiesListing",
  data() {
    return {
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      dataTableOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      properties: [],
      alerts: [],
      search: "",
      isLoading: true,
      totalItems: 0,
      lastPage: 1,
      itemsPerPage: DEFAULT_ITEMS_PER_PAGE_OPTIONS[0],
      options: {},
      sortBy: "name",
      sortDesc: false,
      sortOrd: "ASC",
      sort: {},
      showAlert: false,
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      autocompleteValueLocal: "off",
      isDebounceCancelled: false,
    };
  },
  async mounted() {
    this.$store.commit("setFormMode", VIEW_MODE);
    this.header = { Authorization: "Bearer " + this.token };
    this.autocompleteValueLocal = this.autocompleteValue();
    this.headers.push({});
    this.headers.splice(-1);
    await this.applyPreviousFilters();
    this.fetchData();
  },
  methods: {
    debounceInput: _.debounce(function () {
      if (this.isDebounceCancelled) {
        this.isDebounceCancelled = false;
        return false;
      }
      this.fetchData();
    }, 500),
    updateLocalStorage() {
      let filters = {
        items_per_page: this.itemsPerPage,
        sortBy: this.sortBy,
        sortOrd: this.sortOrd,
        search: this.search ?? "",
      };
      localStorage.setItem("PROPERTIES_LISTING_FILTERS", JSON.stringify(filters));
    },
    applyPreviousFilters() {
      return new Promise((resolve) => {
        let savedFilters = JSON.parse(
          localStorage.getItem("PROPERTIES_LISTING_FILTERS")
        );

        if (savedFilters != null) {
          this.itemsPerPage = savedFilters.items_per_page;
          this.sortBy = savedFilters.sortBy;
          this.sortOrd = savedFilters.sortOrd;
          this.search = savedFilters.search;
        }
        return resolve();
      });
    },
    getPropertyName(item) {
      if (!item) return "";
      return item.name || item.property_name || "";
    },
    getPropertyIdentifier(item) {
      if (!item) return "";
      return (
        item.property_identifier ||
        item.identifier ||
        item.reference ||
        item.code ||
        ""
      );
    },
    getPropertyAddress(item) {
      if (!item) return "";
      const addr = item.address || item;
      if (addr.formatted) return addr.formatted;
      const parts = [];
      const street = addr.street_address || addr.address1 || addr.street || "";
      if (street) parts.push(street);
      const zip = addr.zip || addr.zipcode || addr.postal_code || "";
      if (zip) parts.push(zip);
      const city =
        typeof addr.city === "object"
          ? addr.city?.name || addr.city?.value || ""
          : addr.city || "";
      if (city) parts.push(city);
      const country =
        typeof (addr.country || addr.country_code) === "object"
          ? (addr.country || addr.country_code)?.name || (addr.country || addr.country_code)?.key || ""
          : addr.country || addr.country_name || addr.country_code || "";
      if (country) parts.push(country);
      return parts.join(", ");
    },
    onNoteClick(item) {
      if (item.note) {
        this.$toast.info(item.note);
      }
    },
    fetchData(currentPage = null) {
      if (!currentPage) {
        this.options.page = 1;
        this.resetDataTable(currentPage);
      }

      this.isLoading = true;
      const payload = {
        page: this.page,
        items_per_page: this.itemsPerPage,
        order_by: this.sortBy,
        order_direction: this.sortOrd,
        search: this.search,
      };
      axios({
        method: "get",
        url: API_BASE_URL + "/properties",
        headers: this.header,
        params: payload,
      })
        .then((data) => {
          const response = data.data;
          this.properties = response.data || response;
          this.totalItems = response.total ?? (response.data || response).length;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.success(this.$t("something_went_wrong"));
        });
    },
    updatePagination(page) {
      this.page = page;
      this.fetchData(page);
    },
    updateItemsPerPage(itemsPerPage) {
      itemsPerPage == -1
        ? (this.itemsPerPage = this.totalItems)
        : (this.itemsPerPage = itemsPerPage);
      this.fetchData();
    },
    editProperty(item) {
      this.$store.commit("seteditId", item.id);
      this.$router.push("/property/edit").catch(() => {});
    },
    updateSort(sortBy) {
      if (typeof sortBy == "object") {
        this.sortBy = sortBy[0];
      } else {
        this.sortBy = sortBy;
      }
    },
    updateSortOrder(sortDesc) {
      if (typeof sortDesc == "object") {
        !sortDesc[0] ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      } else {
        !sortDesc ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      }
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("vehicles.id"), value: "id", sortable: true },
        {
          text: this.$t("rentals.property_name"),
          value: "name",
          sortable: true,
        },
        {
          text: this.$t("properties.identifier"),
          value: "property_identifier",
          sortable: false,
        },
        // {
        //   text: this.$t("address"),
        //   value: "address",
        //   sortable: false,
        // },
        { text: this.$t("vehicles.note"), value: "note", sortable: false },
      ];
    },
  },
  watch: {
    sortOrd: {
      handler: function () {
        this.fetchData();
      },
    },
    sortBy: {
      handler: function () {
        this.fetchData();
      },
    },
  },
};
</script>
<style scoped></style>
